import { IonIcon } from '@ionic/react'
import * as Icons from 'ionicons/icons'

interface Props {
  name?: string
}

const IonIconRender = ({ name }: Props) => {
  if (!name) return null

  const camelCaseName = name.replace(/-([a-z])/g, (g) => g[1].toUpperCase())
  const icon = Icons[camelCaseName as keyof typeof Icons]

  if (!icon) {
    return 'icon not found'
  }

  return (
    <IonIcon
      icon={icon}
      style={{
        fontSize: 20,
      }}
    />
  )
}

type IonIconRenderType = { Render: typeof IonIconRender }

export { IonIconRender, type IonIconRenderType }
